import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { authGuard } from '@interceptors/guards/auth.guard'
import { tenantGuard } from '@interceptors/guards/tenant.guard'
import { authorizationContextGuard } from '@interceptors/guards/authorization-context.guard'
import { supplierProductGuard } from '@interceptors/guards/supplier-product.guard'
import { signerProductGuard } from '@interceptors/guards/signer-product.guard'
import { visitorProductGuard } from '@interceptors/guards/visitor-product.guard'
import { portalEnrollmentRedirectGuard } from '@interceptors/guards/portal-enrollment-redirect.guard'

export const routes: Routes = [
	{
		path: '',
		pathMatch: 'full',
		redirectTo: '/auth/signin'
	},
	{
		path: 'auth',
		loadChildren: () => import('@app/security/security.module').then(m => m.SecurityModule)
	},
	{
		path: 'dashboard',
		canActivate: [authGuard, tenantGuard, authorizationContextGuard],
		loadChildren: () => import('@app/dashboard/dashboard-summary.module').then(m => m.DashboardSummaryModule)
	},
	{
		path: 'organization',
		canActivate: [authGuard],
		loadChildren: () => import('@app/organization/organization.module').then(m => m.OrganizationModule)
	},
	{
		path: 'supplier',
		canActivate: [authGuard, supplierProductGuard],
		loadChildren: () => import('@app/supplier/supplier.module').then(m => m.SupplierModule)
	},
	{
		path: 'signer',
		canActivate: [authGuard, signerProductGuard],
		loadChildren: () => import('@app/signer/signer.module').then(m => m.SignerModule)
	},
	{
		// Visitante (spec 048): o cidadão que acompanha processos e sessões em leitura. A ativação do perfil fica em
		// `/auth/visitor-activation`, fora daqui, porque esta área exige o papel.
		path: 'visitor',
		canActivate: [authGuard, visitorProductGuard],
		loadChildren: () => import('@app/visitor/visitor.module').then(m => m.VisitorModule)
	},
	{
		path: 'account',
		canActivate: [authGuard],
		loadChildren: () => import('@app/account/account.module').then(m => m.AccountModule)
	},
	{
		path: 'support',
		canActivate: [authGuard],
		loadChildren: () => import('@app/support/support.module').then(m => m.SupportModule)
	},
	{
		path: 'copyright',
		loadChildren: () => import('@app/public/copyright/copyright.module').then((m) => m.CopyrightModule)
	},
	{
		path: 'portal/:domain',
		loadChildren: () => import('@app/public/portal/portal.module').then((m) => m.PortalModule)
	},
	{
		// Link CURTO de inscrição no processo (`/processo/{externalCode}`): mesmo efeito da rota
		// completa `/portal/{domain}/processes/{externalCode}/enrollment` — o guard decide o destino
		// só pelo processo (signin com redirect, role-select ou /supplier/board) e sempre redireciona,
		// por isso a rota é componentless (children vazio nunca chega a ativar).
		path: 'processo/:numProcess',
		canActivate: [portalEnrollmentRedirectGuard],
		children: []
	},
	{
		path: 'org',
		canActivate: [authGuard, tenantGuard, authorizationContextGuard],
		loadChildren: () => import('@app/management/management.module').then(m => m.ManagementModule)
	},
	{
		path: '**',
		pathMatch: 'full',
		loadChildren: () => import('@modules/error/error-routing.module').then(m => m.ErrorRoutingModule)
	}
]

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			anchorScrolling: 'enabled',
			scrollPositionRestoration: 'enabled'
		})
	],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
